import type { RootState } from '@/store';

import type { ApuracaoStatus, TipoCliente } from '../types';

export const selectApuracoes = (state: RootState) => state.apuracao.apuracoes;
export const selectApuracoesLoading = (state: RootState) => state.apuracao.loading;
export const selectApuracoesSaving = (state: RootState) => state.apuracao.saving;
export const selectApuracoesError = (state: RootState) => state.apuracao.error;
export const selectApuracoesSummary = (state: RootState) => state.apuracao.summary;
export const selectApuracoesFilters = (state: RootState) => state.apuracao.filters;

export const selectApuracaoById = (id: string) => (state: RootState) =>
  state.apuracao.apuracoes.find((a) => a.id === id) ?? null;

export const selectApuracoesByStatus = (status: ApuracaoStatus) => (state: RootState) =>
  state.apuracao.apuracoes.filter((a) => a.status === status);

export const selectApuracoesByTipoCliente = (tipo: TipoCliente) => (state: RootState) =>
  state.apuracao.apuracoes.filter((a) => a.tipoCliente === tipo);

export const selectRejectedInvoices = (state: RootState) => state.apuracao.rejectedInvoices;

export const selectRejectedInvoicesLoading = (state: RootState) =>
  state.apuracao.rejectedInvoicesLoading;

export const selectEventosRejeitadosFilters = (state: RootState) =>
  state.apuracao.eventosRejeitadosFilters;

export const selectEventoDetalhe = (state: RootState) => state.apuracao.eventoDetalhe;

export const selectEventoDetalheLoading = (state: RootState) => state.apuracao.eventoDetalheLoading;
